import { Reveal } from "./Reveal";
import { REVIEWS } from "../lib/data";

const Quote = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" className="text-[var(--cx-gold)]/50">
    <path d="M9.5 5C6.5 5 4 7.5 4 10.5c0 2.6 1.9 4.7 4.4 5C7.9 17 6.5 18 5 18v2c4 0 6.5-3 6.5-7.5V10c0-2.8-.9-5-2-5Zm10 0c-3 0-5.5 2.5-5.5 5.5 0 2.6 1.9 4.7 4.4 5-.5 1.5-1.9 2.5-3.4 2.5v2c4 0 6.5-3 6.5-7.5V10c0-2.8-.9-5-2-5Z" fill="currentColor"/>
  </svg>
);

export const Recensioni = () => (
  <section id="recensioni" data-testid="recensioni-section" className="py-24 md:py-36">
    <div className="cx-container">
      <Reveal>
        <p className="overline">Recensioni</p>
        <h2 className="mt-4 max-w-3xl font-display text-4xl font-light leading-none text-[var(--cx-white)] md:text-6xl">
          La fiducia di chi ci ha già <span className="gold-text italic">scelto</span>.
        </h2>
      </Reveal>
      <div className="mt-16 grid gap-6 md:grid-cols-2">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={i * 0.08}>
            <div
              data-testid={`review-${i}`}
              className="group flex h-full flex-col border border-[var(--cx-border)] bg-[var(--cx-surface)] p-8 transition-colors duration-500 hover:border-[var(--cx-gold)]/50 md:p-10"
            >
              <Quote />
              <p className="mt-6 flex-1 font-display text-2xl font-light italic leading-snug text-[var(--cx-white)]/90 md:text-3xl">
                “{r.quote}”
              </p>
              <div className="mt-8 border-t border-[var(--cx-border)] pt-5">
                <p className="font-body text-base text-[var(--cx-white)]">{r.name}</p>
                <p className="mt-1 font-body text-sm tracking-wide text-[var(--cx-gold)]">{r.role}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
